import axios from "axios";

//var host = "http://localhost:8000/api/student/"
var host = "http://adminonline.clovermandalay.org/api/student/";
var dict_url='http://dictionarymanage.clovermandalay.org/api/';
export async function sendData(url, data) {
  var url = host + url;
  var user = JSON.parse(localStorage.getItem("online_learning_site_user"));
  if (user) {
    data.append("token", user.token);
    data.append("user_id", user.user_id);
  }

  try {
    var response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    alert("Server Error");
    console.log(error);
  }
}

export async function sendDataToDict(url, data) {
  var url = dict_url + url;


  try {
    var response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    alert("Server Error");
    console.log(error);
  }
}

export async function getData(url) {
  var url = host + url;

  var user = JSON.parse(localStorage.getItem("online_learning_site_user"));

  if (user) {
    if (url[url.length - 1] != "&") {
      url += "?";
    }
    url += "user_id=" + user.user_id;
    url += "&token=" + user.token;
  }

  try {
    var response = await axios.get(url);
    return response.data;
  } catch (error) {
    alert("Server Error");
    console.log(error);
  }
}
